"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.meltSpore = void 0;
const lumos_1 = require("@ckb-lumos/lumos");
const helpers_1 = require("../../../helpers");
const config_1 = require("../../../config");
const __1 = require("../..");
const cobuild_1 = require("../../../cobuild");
async function meltSpore(props) {
    // Env
    const config = props.config ?? (0, config_1.getSporeConfig)();
    const indexer = new lumos_1.Indexer(config.ckbIndexerUrl, config.ckbNodeUrl);
    // TransactionSkeleton
    let txSkeleton = lumos_1.helpers.TransactionSkeleton({
        cellProvider: indexer,
    });
    // Inject live spore to Transaction.inputs
    const sporeCell = await (0, __1.getSporeByOutPoint)(props.outPoint, config);
    const injectLiveSporeCellResult = await (0, __1.injectLiveSporeCell)({
        txSkeleton,
        cell: sporeCell,
        updateWitness: props.updateWitness,
        defaultWitness: props.defaultWitness,
        since: props.since,
        config,
    });
    txSkeleton = injectLiveSporeCellResult.txSkeleton;
    // Inject CobuildProof
    const sporeScript = (0, config_1.getSporeScript)(config, 'Spore', sporeCell.cellOutput.type);
    if (sporeScript.behaviors?.cobuild) {
        const actionResult = (0, cobuild_1.generateMeltSporeAction)({
            txSkeleton: txSkeleton,
            inputIndex: injectLiveSporeCellResult.inputIndex,
        });
        const injectCobuildProofResult = (0, cobuild_1.injectCommonCobuildProof)({
            txSkeleton: txSkeleton,
            actions: actionResult.actions,
        });
        txSkeleton = injectCobuildProofResult.txSkeleton;
    }
    // Redeem capacity from the melted spore
    const sporeAddress = lumos_1.helpers.encodeToAddress(sporeCell.cellOutput.lock, { config: config.lumos });
    const returnExceededCapacityAndPayFeeResult = await (0, helpers_1.returnExceededCapacityAndPayFee)({
        changeAddress: props.changeAddress ?? sporeAddress,
        txSkeleton,
        config,
    });
    txSkeleton = returnExceededCapacityAndPayFeeResult.txSkeleton;
    return {
        txSkeleton,
        inputIndex: injectLiveSporeCellResult.inputIndex,
    };
}
exports.meltSpore = meltSpore;
//# sourceMappingURL=meltSpore.js.map